import { render, staticRenderFns } from "./Plane.vue?vue&type=template&id=c782700e"
import script from "./Plane.vue?vue&type=script&lang=js"
export * from "./Plane.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports